import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { SpinnerService } from './spinner.service';
import { ToastService } from './toast.service';
import { ITimetable, Timetable } from '../models/timetable.model';
import { Amenity } from '../models/amenity.model';
import { environment } from '../../environments/environment';
import { IServerResponse, ServerResponse } from '../models/server-response.model';
import { AmenityService } from './amenity.service';

@Injectable({
  providedIn: 'root'
})
export class TimetableService {

  public loading: boolean = false;

  constructor(
    public amenityService: AmenityService,
    public authService: AuthService,
    private http: HttpClient,
    public spinnerService: SpinnerService,
    public toastService: ToastService
  ) {}

  /*
   ██████╗██████╗ ███████╗ █████╗ ████████╗███████╗
  ██╔════╝██╔══██╗██╔════╝██╔══██╗╚══██╔══╝██╔════╝
  ██║     ██████╔╝█████╗  ███████║   ██║   █████╗  
  ██║     ██╔══██╗██╔══╝  ██╔══██║   ██║   ██╔══╝  
  ╚██████╗██║  ██║███████╗██║  ██║   ██║   ███████╗
   ╚═════╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝   ╚═╝   ╚══════╝
  */

   async create(
    amenity: Amenity,
    timetable: ITimetable
  ): Promise<boolean> {

    let flag = false;
    const urlApi = `${environment.urlApi}/neighborhoods/${amenity.neighborhoodId}/amenities/${amenity.amenityId}/timetables`;

    this.spinnerService.loading = true;
    this.spinnerService.message = 'Registrando horario';

    try {
      const token = await this.authService.getToken();

      const response = await new Promise<ServerResponse>(
        (resolve, reject) => {
          this.http.post<IServerResponse>(
            urlApi,
            JSON.stringify(timetable),
            {
              headers: {
                "content-type": "application/json",
                "Authorization": token.toString()
              }
            }
          ).subscribe({
            next: (
              response: IServerResponse
            ) => resolve(new ServerResponse(response)),

            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
                this.toastService.show({
                  header: 'Error de servidor',
                  body: `${error}`,
                  classname: 'bg-danger text-white'
                });
              }
            }
          });
        }
      );

      console.log(response);
      

      if (response.statusCode === 201) {
        flag = true;
        this.toastService.show({
          body: `${response.message}`,
          classname: 'bg-success text-white'
        });

        this.amenityService.getAll(
          amenity.neighborhoodId
        );

      } else {
        this.toastService.show({
          header: 'Error de servidor',
          body: `${response.message}`,
          classname: 'bg-danger text-white'
        });
      }

    } catch (error) {
      console.log(error);
      this.toastService.show({
        header: 'Error',
        body: `${error}`,
        classname: 'bg-danger text-white'
      });
    }

    this.spinnerService.loading = false;
    this.spinnerService.message = '';
    return flag;
  }

  /*
  ██████╗ ███████╗██╗     ███████╗████████╗███████╗
  ██╔══██╗██╔════╝██║     ██╔════╝╚══██╔══╝██╔════╝
  ██║  ██║█████╗  ██║     █████╗     ██║   █████╗
  ██║  ██║██╔══╝  ██║     ██╔══╝     ██║   ██╔══╝
  ██████╔╝███████╗███████╗███████╗   ██║   ███████╗
  ╚═════╝ ╚══════╝╚══════╝╚══════╝   ╚═╝   ╚══════╝

  */
  async delete(
    amenity: Amenity,
    timetable: Timetable
  ): Promise<boolean> {
  
    let flag = false;
  
    const urlApi = `${environment.urlApi}/neighborhoods/${amenity.neighborhoodId}/amenities/${amenity.amenityId}/timetables/${timetable.timetableId}`;
    this.spinnerService.loading = true;
    this.spinnerService.message = 'Eliminando horario';
  
    try {
      const token = await this.authService.getToken();
  
      const response = await new Promise<ServerResponse>(
        (resolve, reject) => {
          this.http.delete<IServerResponse>(
            urlApi,
            {
              headers: {
                'Authorization': token.toString()
              }
            }
          ).subscribe({
            next: (
              response: IServerResponse
            ) => resolve(
              new ServerResponse(response)
            ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
                this.toastService.show({
                  header: 'Error de servidor',
                  body: `${error}`,
                  classname: 'bg-danger text-white'
                });
              }
            }
          });
        }
      );
  
      if (response.statusCode === 200) {
        flag = true;
  
        this.toastService.show({
          body: `${response.message}`,
          classname: 'bg-success text-white'
        });
  
        this.getAll(amenity);
      } else {
        this.toastService.show({
          header: 'Error de servidor',
          body: `${response.message}`,
          classname: 'bg-danger text-white'
        });
      }
  
    } catch (error) {
      console.log(error);
      this.toastService.show({
        header: 'Error',
        body: `${error}`,
        classname: 'bg-danger text-white'
      });
    }
  
    this.spinnerService.loading = false;
    this.spinnerService.message = '';
    return flag;
  }
  

  /*
   ██████╗ ███████╗████████╗ █████╗ ██╗     ██╗
  ██╔════╝ ██╔════╝╚══██╔══╝██╔══██╗██║     ██║
  ██║  ███╗█████╗     ██║   ███████║██║     ██║
  ██║   ██║██╔══╝     ██║   ██╔══██║██║     ██║
  ╚██████╔╝███████╗   ██║   ██║  ██║███████╗███████╗
   ╚═════╝ ╚══════╝   ╚═╝   ╚═╝  ╚═╝╚══════╝╚══════╝

  */
  async getAll(
    amenity: Amenity
  ): Promise<Timetable[]> {

    this.loading = true;
    let timetables: Timetable[] = [];
  
    const urlApi = `${environment.urlApi}/neighborhoods/${amenity.neighborhoodId}/amenities/${amenity.amenityId}/timetables`;
  
    try {
      const token = await this.authService.getToken();
  
      const response = await new Promise<ServerResponse<{ timetables: ITimetable[] }>>(
        (resolve, reject) => {
          this.http.get<IServerResponse<{ timetables: ITimetable[] }>>(
            urlApi,
            {
              headers: {
                "content-type": "application/json",
                "Authorization": token.toString()
              }
            }
          ).subscribe({
            next: (
              response: IServerResponse<{ timetables: ITimetable[] }>
            ) => resolve(
              new ServerResponse<{ timetables: ITimetable[] }>(response)
            ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
                this.toastService.show(
                  {
                    header: 'Error de servidor',
                    body: `${error}`,
                    classname: 'bg-danger text-white'
                  }
                );
              }
            }
          });
        }
      );

      console.log(response);
      
  
      if (response.statusCode === 200) {
        timetables = response.data!.timetables.map(
          (timetable) => new Timetable(timetable)
        );
      } else {
        this.toastService.show(
          {
            header: 'Error de servidor',
            body: `${response.message}`,
            classname: 'bg-danger text-white'
          }
        );
      }
  
    } catch (error) {
      console.log(error);
      this.toastService.show(
        {
          header: 'Error',
          body: `${error}`,
          classname: 'bg-danger text-white'
        }
      );
    }
  
    this.loading = false;

    return timetables;
  }
  

  /*
  ██╗   ██╗██████╗ ██████╗  █████╗ ████████╗███████╗
  ██║   ██║██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔════╝
  ██║   ██║██████╔╝██║  ██║███████║   ██║   █████╗
  ██║   ██║██╔═══╝ ██║  ██║██╔══██║   ██║   ██╔══╝
  ╚██████╔╝██║     ██████╔╝██║  ██║   ██║   ███████╗
   ╚═════╝ ╚═╝     ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
  async update(
    amenity: Amenity,
    timetable: Timetable
  ): Promise<boolean> {
  
    let flag = false;
  
    const urlApi = `${environment.urlApi}/neighborhoods/${amenity.neighborhoodId}/amenities/${amenity.amenityId}/timetables/${timetable.timetableId}`;
    this.spinnerService.loading = true;
    this.spinnerService.message = 'Actualizando horario';
  
    try {
      const token = await this.authService.getToken();
  
      const response = await new Promise<ServerResponse>(
        (resolve, reject) => {
          this.http.put<IServerResponse>(
            urlApi,
            JSON.stringify(timetable),
            {
              headers: {
                "content-type": "application/json",
                'Authorization': token.toString()
              }
            }
          ).subscribe({
            next: (
              response: IServerResponse
            ) => resolve(
              new ServerResponse(response)
            ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
                this.toastService.show(
                  {
                    header: 'Error de servidor',
                    body: `${error}`,
                    classname: 'bg-danger text-white'
                  }
                );
              }
            },
          });
        }
      );
  
      if (response.statusCode === 200) {
        flag = true;
  
        this.toastService.show(
          {
            body: `${response.message}`,
            classname: 'bg-success text-white'
          }
        );

        this.amenityService.getAll(
          amenity.neighborhoodId
        );

      } else {
        this.toastService.show(
          {
            header: 'Error de servidor',
            body: `${response.message}`,
            classname: 'bg-danger text-white'
          }
        );
      }
  
    } catch (error) {
      console.log(error);
  
      this.toastService.show(
        {
          header: 'Error',
          body: `${error}`,
          classname: 'bg-danger text-white'
        }
      );
    }
  
    this.spinnerService.loading = false;
    this.spinnerService.message = '';
    return flag;
  }
  

}
